'use client';

import { c as _c } from "react/compiler-runtime";
import { ALLOWED_MEDIA, normalizeSrc, ResponsiveImage } from '@/app/components/media/app-image';
import type { SpartanProductCustomizeBufferedImageProps } from '@/app/lcv/components/sections/spartan/products/customize/configurator/preview-media/buffered-image/types';
import { useBufferedImage } from '@/app/lcv/components/sections/spartan/products/customize/configurator/preview-media/buffered-image/useBufferedImage';
import { PREVIEW_CROSSFADE_CLASS_NAME } from '@/app/lcv/components/sections/spartan/products/customize/configurator/preview-media/constants';
import { cn } from '@/app/utils/cn';
export const SpartanProductCustomizeBufferedImage = t0 => {
  const $ = _c(70);
  let alt;
  let className;
  let desktopWidths;
  let fade;
  let fetchPriority;
  let loading;
  let mobileWidths;
  let onImageError;
  let onImageLoad;
  let onSwapStart;
  let params;
  let props;
  let src;
  let surfaceClassName;
  let surfaceTone;
  let t1;
  let t2;
  let t3;
  let testId;
  if ($[0] !== t0) {
    ({
      src,
      alt,
      className,
      fade,
      testId,
      onImageLoad,
      onImageError,
      onSwapStart,
      swapEffect: t1,
      holdSurfaceTone: t2,
      surfaceClassName,
      surfaceTone,
      mobileWidths,
      desktopWidths,
      sizes: t3,
      params,
      fetchPriority,
      loading,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = alt;
    $[2] = className;
    $[3] = desktopWidths;
    $[4] = fade;
    $[5] = fetchPriority;
    $[6] = loading;
    $[7] = mobileWidths;
    $[8] = onImageError;
    $[9] = onImageLoad;
    $[10] = onSwapStart;
    $[11] = params;
    $[12] = props;
    $[13] = src;
    $[14] = surfaceClassName;
    $[15] = surfaceTone;
    $[16] = t1;
    $[17] = t2;
    $[18] = t3;
    $[19] = testId;
  } else {
    alt = $[1];
    className = $[2];
    desktopWidths = $[3];
    fade = $[4];
    fetchPriority = $[5];
    loading = $[6];
    mobileWidths = $[7];
    onImageError = $[8];
    onImageLoad = $[9];
    onSwapStart = $[10];
    params = $[11];
    props = $[12];
    src = $[13];
    surfaceClassName = $[14];
    surfaceTone = $[15];
    t1 = $[16];
    t2 = $[17];
    t3 = $[18];
    testId = $[19];
  }
  const swapEffect = t1 === undefined ? "none" : t1;
  const holdSurfaceTone = t2 === undefined ? false : t2;
  const sizes = t3 === undefined ? "100vw" : t3;
  let t4;
  if ($[20] !== holdSurfaceTone || $[21] !== onImageError || $[22] !== onImageLoad || $[23] !== onSwapStart || $[24] !== src || $[25] !== surfaceClassName || $[26] !== surfaceTone || $[27] !== swapEffect) {
    t4 = {
      src,
      onImageLoad,
      onImageError,
      onSwapStart,
      swapEffect,
      holdSurfaceTone,
      surfaceClassName,
      surfaceTone
    };
    $[20] = holdSurfaceTone;
    $[21] = onImageError;
    $[22] = onImageLoad;
    $[23] = onSwapStart;
    $[24] = src;
    $[25] = surfaceClassName;
    $[26] = surfaceTone;
    $[27] = swapEffect;
    $[28] = t4;
  } else {
    t4 = $[28];
  }
  const {
    layers,
    activeIndex,
    incomingIndex,
    isIncomingVisible,
    handleLayerLoad,
    handleLayerError
  } = useBufferedImage(t4);
  let t5;
  if ($[29] !== layers) {
    t5 = layers.every(_temp);
    $[29] = layers;
    $[30] = t5;
  } else {
    t5 = $[30];
  }
  const hasBufferedReplacement = t5;
  let t6;
  if ($[31] !== activeIndex || $[32] !== alt || $[33] !== className || $[34] !== desktopWidths || $[35] !== fade || $[36] !== fetchPriority || $[37] !== handleLayerError || $[38] !== handleLayerLoad || $[39] !== hasBufferedReplacement || $[40] !== incomingIndex || $[41] !== isIncomingVisible || $[42] !== layers || $[43] !== loading || $[44] !== mobileWidths || $[45] !== params || $[46] !== props || $[47] !== sizes || $[48] !== testId) {
    let t7;
    if ($[50] !== activeIndex || $[51] !== alt || $[52] !== className || $[53] !== desktopWidths || $[54] !== fade || $[55] !== fetchPriority || $[56] !== handleLayerError || $[57] !== handleLayerLoad || $[58] !== hasBufferedReplacement || $[59] !== incomingIndex || $[60] !== isIncomingVisible || $[61] !== loading || $[62] !== mobileWidths || $[63] !== params || $[64] !== props || $[65] !== sizes || $[66] !== testId) {
      t7 = (layer_0, index) => {
        if (!layer_0) {
          return null;
        }
        const isActive = index === activeIndex;
        const isIncoming = index === incomingIndex;
        const shouldKeepLoaded = hasBufferedReplacement || !isActive;
        return <div key={`${index}:${layer_0.key}`} className={cn(className, layer_0.surfaceClassName, isIncoming && PREVIEW_CROSSFADE_CLASS_NAME, isActive ? "relative z-0 opacity-100" : "absolute inset-0", {
          "pointer-events-none z-10 opacity-100": isIncoming && isIncomingVisible,
          "pointer-events-none z-10 opacity-0": isIncoming && !isIncomingVisible,
          "pointer-events-none z-0 opacity-0": !isActive && !isIncoming
        })} {...layer_0.surfaceTone ? {
          "data-preview-tone": layer_0.surfaceTone
        } : undefined}>{!layer_0.isFailed && <ResponsiveImage {...props} mobileSrc={{
            src: normalizeSrc(layer_0.src),
            media: ALLOWED_MEDIA.lgDown,
            sizes,
            widths: mobileWidths,
            params
          }} desktopSrc={{
            src: normalizeSrc(layer_0.src),
            media: ALLOWED_MEDIA.lgUp,
            sizes,
            widths: desktopWidths,
            params
          }} alt={isActive ? alt : ""} fade={fade} fetchPriority={shouldKeepLoaded ? "low" : fetchPriority} loading={shouldKeepLoaded ? "eager" : loading} className="size-full" onLoad={event => handleLayerLoad(index, event.currentTarget)} onError={() => handleLayerError(index)} testId={isActive ? testId : testId ? `${testId}-buffer-${index}` : undefined} />}</div>;
      };
      $[50] = activeIndex;
      $[51] = alt;
      $[52] = className;
      $[53] = desktopWidths;
      $[54] = fade;
      $[55] = fetchPriority;
      $[56] = handleLayerError;
      $[57] = handleLayerLoad;
      $[58] = hasBufferedReplacement;
      $[59] = incomingIndex;
      $[60] = isIncomingVisible;
      $[61] = loading;
      $[62] = mobileWidths;
      $[63] = params;
      $[64] = props;
      $[65] = sizes;
      $[66] = testId;
      $[67] = t7;
    } else {
      t7 = $[67];
    }
    t6 = layers.map(t7);
    $[31] = activeIndex;
    $[32] = alt;
    $[33] = className;
    $[34] = desktopWidths;
    $[35] = fade;
    $[36] = fetchPriority;
    $[37] = handleLayerError;
    $[38] = handleLayerLoad;
    $[39] = hasBufferedReplacement;
    $[40] = incomingIndex;
    $[41] = isIncomingVisible;
    $[42] = layers;
    $[43] = loading;
    $[44] = mobileWidths;
    $[45] = params;
    $[46] = props;
    $[47] = sizes;
    $[48] = testId;
    $[49] = t6;
  } else {
    t6 = $[49];
  }
  let t7;
  if ($[68] !== t6) {
    t7 = <div className="relative">{t6}</div>;
    $[68] = t6;
    $[69] = t7;
  } else {
    t7 = $[69];
  }
  return t7;
};
function _temp(layer) {
  return layer !== null;
}